<div class="course-play-container">
  <div class="title">
    <div class="main-title">{{ courseDetails?.title }}</div>
    <div class="sub-title">
      {{ courseDetails?.description }}
    </div>
  </div>
  <div class="content">
    <div class="video" *ngIf="isLesson && !isEmptyObject(selectedLesson) && courseId && moduleId">
      <video id="videoPlayer" width="100%" controls autoplay>
        <source [src]="
            apiURL +
            '/api/course/' +
            courseId +
            '/module/' +
            moduleId +
            '/lesson/' +
            selectedLesson._id +
            '/video/' +
            selectedLesson.video._id
          " type="video/mp4" />
      </video>
    </div>
    <div class="quiz" *ngIf="isQuiz && quiz">
      <app-view-quiz [quiz]="quiz" [moduleId]="moduleId" (isComplete)="onCompleteQuiz($event)"
        [courseId]="courseId"></app-view-quiz>
    </div>
    <div class="feedback" *ngIf="isFeedback">
      <app-feedback [courseDetails]="courseDetails" [purchaseCourseId]="purchasedCourseId">
      </app-feedback>
    </div>
    <div class="about">
      <div class="title">About this course</div>
      <div class="desc">
        {{ courseDetails?.description }}
      </div>
    </div>
    <div class="modules-and-lessons">
      <div class="title">Course content</div>
      <div class="accordion" *ngFor="let module of modules; let i = index">
        <div [ngClass]="
            module.active ? 'module-and-lessons-active' : 'module-and-lessons'
          ">
          <div class="module" (click)="onClickModule(i)">
            <div class="left">
              <div class="icon">
                <i class="fa-solid fa-circle-check"></i>
              </div>
            </div>
            <div class="right">
              <div class="name">
                <div class="title">
                  {{ module.title }}
                </div>
                <div class="pdf-icon"
                  (click)="onDownloadMaterial($event, module.material[0].buffer, module.material[0].originalname)"
                  *ngIf="module.material.length">
                  <i class="fa-solid fa-file-pdf"></i>
                </div>
              </div>
              <div class="duration">{{ module.duration || "1 hour" }}</div>
              <div class="desc">
                {{ module.description }}
              </div>
            </div>
          </div>
          <div [ngClass]="module.active ? 'panel-active' : 'panel'">
            <div class="lesson" [ngClass]="{ 'active-lesson': lesson._id === selectedLesson._id }"
              *ngFor="let lesson of lessons; let i = index" (click)="onClickLesson(i)">
              <div class="left">
                <div class="icon">
                  <i class="fa-solid fa-circle-check"></i>
                </div>
              </div>
              <div class="middle">
                <div class="name">{{ lesson.title }}</div>
              </div>
              <div class="right">
                <div class="duration">{{ lesson.duration || '15 minutes'}}</div>
              </div>
            </div>
            <div class="lesson quiz" (click)="onClickQuiz(i)" *ngIf="isShowingQuiz">
              <div class="left">
                <div class="icon">
                  <i class="fa-solid fa-circle-check"></i>
                </div>
              </div>
              <div class="middle">
                <div class="name">Quiz</div>
              </div>
            </div>
            <div class="lesson feeback" (click)="onClickFeedback()" *ngIf="i == modules.length - 1">
              <div class="left">
                <div class="icon">
                  <i class="fa-solid fa-circle-check"></i>
                </div>
              </div>
              <div class="middle">
                <div class="name">Feedback</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>